import type { PaginationUrlFilterScalarValueType } from '@/services/tables/types'
import type { TFilterRange } from '@/services/filters/types'

export const mapFilterToRange = <T extends string = string>(
  filterValue: PaginationUrlFilterScalarValueType,
): TFilterRange<T> | undefined => {
  if (!filterValue || typeof filterValue !== 'object') return undefined

  type StartOp = 'gte' | 'gt'
  type EndOp = 'lte' | 'lt'

  let startOp: StartOp | undefined
  if ('gte' in filterValue && filterValue.gte) {
    startOp = 'gte'
  } else if ('gt' in filterValue && filterValue.gt) {
    startOp = 'gt'
  }

  let endOp: EndOp | undefined
  if ('lte' in filterValue && filterValue.lte) {
    endOp = 'lte'
  } else if ('lt' in filterValue && filterValue.lt) {
    endOp = 'lt'
  }

  const start = startOp ? (filterValue[startOp] as T) : undefined
  const end = endOp ? (filterValue[endOp] as T) : undefined

  if (!startOp && !endOp) return undefined

  if (startOp && start && endOp && end) {
    return {
      startOperation: startOp,
      start,
      endOperation: endOp,
      end,
    }
  }

  if (startOp && start) {
    return {
      startOperation: startOp,
      start,
      endOperation: undefined,
      end: undefined,
    }
  }

  if (endOp && end) {
    return {
      startOperation: undefined,
      start: undefined,
      endOperation: endOp,
      end,
    }
  }

  return undefined
}
